import React, { useEffect, useState } from "react";
import {
  Box,
  Button,
  Dialog,
  Grid,
  IconButton,
  Typography,
} from "@mui/material";

import AnalyticsService from "../../Services/AnalyticsService";
import { Close, Error } from "@mui/icons-material";
import { useNavigate } from "react-router-dom";
import useQuery from "../../Hooks/useQuery";
import makeStyles from "@mui/styles/makeStyles";

const useStyles = makeStyles(() => ({
  buttonStyle: {
    borderRadius: "0",
    fontWeight: 700,
    fontSize: "14px",
    lineHeight: "normal",
    letterSpacing: "0.56px",
    textTransform: "uppercase",
  },
}));

const FieldAgentOrderConfirmationFailure = () => {
  const classes = useStyles();
  let navigate = useNavigate();
  const query = useQuery();
  const documentId = query.get("documentId");

  useEffect(() => {
    AnalyticsService.pushEvent("Page Viewed", {
      type: "Field Agent Order Confirmation Failure",
    });
  }, []);

  return (
    <Dialog fullWidth={true} fullScreen={true} open={true}>
      <Box sx={{ background: "#FAEEEE", height: "92vh" }}>
        <Grid container alignItems={"flex-start"} justifyContent={"flex-start"}>
          <Grid item xs={10} />
          <Grid item xs={2}>
            <IconButton
              size={"large"}
              sx={{ color: "#757575" }}
              onClick={() => {
                AnalyticsService.pushEvent("Button Clicked", {
                  type: "Field Agent Order Confirmation Failure Close Icon",
                });
                navigate("/field-agent-commerce", {
                  replace: "true",
                });
              }}
            >
              <Close />
            </IconButton>
          </Grid>
        </Grid>
        <Grid
          container
          alignItems={"center"}
          justifyContent={"center"}
          sx={{ marginTop: "17vh" }}
        >
          <Grid item>
            <img src="/icons/payment-status-failed.svg" height="150px" alt="" />
          </Grid>
        </Grid>
        <Grid
          container
          alignItems={"center"}
          justifyContent={"center"}
          sx={{ marginTop: "1vh" }}
        >
          <Grid item>
            <Typography
              variant={"h6"}
              align={"center"}
              sx={{ fontWeight: "700" }}
              color={"primary"}
            >
              Failed to confirm the order
            </Typography>
          </Grid>
        </Grid>
        <Grid
          container
          alignItems={"center"}
          justifyContent={"center"}
          sx={{ marginTop: "1vh" }}
        >
          <Grid item xs={9}>
            <Typography
              variant={"body1"}
              align={"center"}
              sx={{ color: "#757575" }}
            >
              Please try again after sometime.
            </Typography>
          </Grid>
        </Grid>
      </Box>
      <Box
        sx={{
          height: "8vh",
          display: "flex",
        }}
      >
        <Button
          variant={"outlined"}
          fullWidth={true}
          color={"secondary"}
          className={classes.buttonStyle}
          sx={{
            background: "#FFF",
            "&:focus": {
              backgroundColor: `#F5F5F5`,
            },
            "&:hover": {
              backgroundColor: `#F5F5F5`,
            },
          }}
          onClick={() => {
            navigate("/field-agent-commerce", {
              replace: "true",
            });
          }}
        >
          Go Back
        </Button>
      </Box>
    </Dialog>
  );
};

export default FieldAgentOrderConfirmationFailure;
